import { customElement } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { getScrollParent } from 'framework/script_utilities/scroll-utils';

@customElement('af-items-loader')
export class ItemsLoader {
  @bindable items: unknown[];
  @bindable fetch: (args: FetchEventArgs) => Promise<unknown[]>;
  @bindable batchSize = 100;
  @bindable initialSize: number = null;
  @bindable template: string = null;
  @bindable showMore = true;
  scrollParent: Element = null;
  notNecessary = true;
  hasMore = false;

  constructor(private element: Element) { }

  attached() {
    this.scrollParent = getScrollParent(this.element, false);
  }

  async fetchMore() {
    const items = this.items;
    const fetchedItems = await this.fetch({ skip: items.length, take: this.batchSize });
    this.hasMore = fetchedItems.length === this.batchSize;
    items.splice(items.length, 0, ...fetchedItems);
  }

  private itemsChanged(items: unknown[]) {
    this.notNecessary = items == null || items.length < (this.initialSize ?? this.batchSize);
    this.hasMore = items != null && items.length === (this.initialSize ?? this.batchSize);
  }

  scrollBack() {
    if (this.scrollParent != null)
      this.scrollParent.scroll({ top: 0, behavior: 'smooth' });
  }
}

export interface FetchEventArgs {
  skip: number;
  take: number;
}
